import { render, staticRenderFns } from "./FormSubmissions.vue?vue&type=template&id=5697ffb0"
import script from "./FormSubmissions.vue?vue&type=script&lang=js"
export * from "./FormSubmissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports